import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ErrorIcon from 'material-design-icons/alert/svg/production/ic_error_48px.svg';
import WarningIcon from 'material-design-icons/alert/svg/production/ic_warning_48px.svg';
import SuccessIcon from 'material-design-icons/action/svg/production/ic_check_circle_48px.svg';

import c from './ScreenFeedback.less';

const iconTypes = {
  error: ErrorIcon,
  warning: WarningIcon,
  success: SuccessIcon,
};

function ScreenFeedback({
  title, icon, helpText, type,
}) {
  const Icon = iconTypes[type];

  return (
    <div>
      <div className={cx(c.container, c[`status-${type}`])}>
        {
          icon || <Icon className={c.icon} />
        }
        <h2 className={c.title}>{title}</h2>
        {helpText && <div className={c.help}>{helpText}</div>}
      </div>
    </div>
  );
}

ScreenFeedback.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  helpText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  type: PropTypes.oneOf(['error', 'warning', 'success']),
};

ScreenFeedback.defaultProps = {
  icon: null,
  helpText: null,
  type: 'error',
};

export default ScreenFeedback;
